import React from "react";
import { Grid, Link, Typography } from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";

import { AuthenticationButton } from "../../../components";

export interface PasswordResetVerifyTimerProps {
	readonly onResendCode: () => void;
	readonly onBackToLogin: () => void;
	readonly timeLeft: number;
}

export const PasswordResetVerifyTimer: React.FC<PasswordResetVerifyTimerProps> = ({
	onResendCode,
	onBackToLogin,
	timeLeft,
}) => {
	const intl = useIntl();

	return (
		<Grid container gap={2} direction="column">
			{timeLeft > 0 && (
				<Typography variant="body2" align="center" color="white">
					<FormattedMessage
						id="password-reset-verify.resend-timer"
						defaultMessage="Didn't receive it? Send a new code in {formattedTime}"
						values={{
							formattedTime: intl.formatRelativeTime(timeLeft, "second"),
						}}
					/>
				</Typography>
			)}

			{timeLeft <= 0 && (
				<AuthenticationButton variant="contained" id="resendButton" onClick={onResendCode}>
					<FormattedMessage id="password-reset-verify.resend-button" defaultMessage="Resend Code" />
				</AuthenticationButton>
			)}

			<Link
				component="button"
				onClick={onBackToLogin}
				data-testid="password-reset-verify__link__back"
				sx={{ alignSelf: "flex-end", color: "white" }}
			>
				<FormattedMessage id="password-reset-verify.back" defaultMessage="Back to login" />
			</Link>
		</Grid>
	);
};
